import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import { Link } from "react-router-dom";
import LayoutTwo from "../layouts/LayoutTwo";
import Breadcrumb from "../components/breadcrumbs/Breadcrumb";
import Logo from "../components/header/Logo";

const Register = () => {
  return (
    <Fragment>
      <MetaTags>
        <title>PIPS | Register</title>
        <meta
          name="description"
          content="Register page for PIPS user portal."
        />
      </MetaTags>
      {/* <LayoutTwo theme="white"> */}
      {/* <Breadcrumb title="REGISTER" /> */}
      {/* <section className="register__area section-padding--xl">
          <div className="container-fluid"> */}
      <section className="register__area">
        <div>
          <div className="row">
            {/* Left Content */}
            <div className="col-lg-6 col-md-12 col-12">
              <div className="register__content">
                <h2>Create New Account</h2>

                <form className="register__form">
                  <div className="input__box">
                    <span>First Name</span>
                    <input type="text" name="firstname" />
                  </div>
                  <div className="input__box">
                    <span>Last Name</span>
                    <input type="text" name="lastname" />
                  </div>
                  <div className="input__box">
                    <span>Email Address</span>
                    <input type="email" name="email" />
                  </div>
                  <div className="input__box">
                    <span>Phone Number</span>
                    <input type="text" name="phone" />
                  </div>
                  <div className="input__box">
                    <span>Password</span>
                    <input type="password" name="password" />
                  </div>
                  <div className="input__box">
                    <span>Confirm Password</span>
                    <input type="password" name="passwordConfirm" />
                  </div>

                  <button className="account__btn">Sign Up</button>

                  <p className="switch__text">
                    Already have an account?{" "}
                    <Link to="/login" className="switch__link">
                      Login
                    </Link>
                  </p>
                </form>
              </div>
            </div>

            {/* Right Image */}
            <div className="col-lg-6 col-md-12 col-12">
              <div className="login__image">
                <img
                  src={
                    process.env.PUBLIC_URL + "/images/login/register.png"
                  }
                  alt="login visual"
                  className="login__image__bg"
                />
                <div className="login__image__content">
                  <Logo image={"/images/logo/logo_white.png"} />
                  <h2>Your Pathway to Trading Global Markets</h2>
                  <h1>
                    Access powerful tools, real-time analytics, and a seamless
                    trading experience, all in one place.
                  </h1>
                  <p>
                    Disclaimer: Trading financial products carries risk. Only
                    trade with capital you can afford to lose.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* </LayoutTwo> */}
    </Fragment>
  );
};

export default Register;
